module.exports = __webpack_public_path__ + "img/case4.4cf4d985.png";